import { Tabs, TabsProps } from "@mantine/core";
import { useColors } from "../../../hooks/colors/useColors";

export function StyledTabs(props: TabsProps) {
  const { colors } = useColors();
  return (
    <Tabs
      unstyled
      styles={(theme) => ({
        tab: {
          // ...theme.s,
          marginRight: "1rem",
          marginLeft: "1rem",
          borderRadius: theme.radius.xl,
          // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
          // color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9],
          border: `none`,
          padding: `0.7rem`,
          cursor: "pointer",
          fontSize: "1.5rem",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",

          "&:disabled": {
            opacity: 0.5,
            cursor: "not-allowed",
          },

          "&:not(:first-of-type)": {
            borderLeft: 0,
          },

          "&:first-of-type": {
            border: theme.radius.xl,
            // borderBottomLeftRadius: theme.radius.md,
          },

          "&:last-of-type": {
            border: theme.radius.xl,
            // borderTopRightRadius: theme.radius.md,
            // borderBottomRightRadius: theme.radius.md,
          },

          "&[data-active]": {
            borderRadius: theme.radius.xl,
            backgroundColor: colors.secondary,
            borderColor: colors.secondary,
            color: theme.white,
          },
        },

        tabIcon: {
          marginRight: theme.spacing.xs,
          display: "flex",
          alignItems: "center",
        },

        tabsList: {
          display: "flex",
        },
      })}
      {...props}
    />
  );
}
